import { Fancybox, Carousel, Lazyload, Arrows, Thumbs } from "@fancyapps/ui/dist/fancybox/";
var detailMainCarousel;

function BuildGallery() {

    detailMainCarousel = Carousel(document.getElementById("detail-carousel"), {

        infinite: false,
        Thumbs: {
            type: "classic",
            Carousel: {

                vertical: true,
                center: (ref) => {
                    return ref.getTotalSlideDim() > ref.getViewportDim();
                },
                breakpoints: {
                    "(max-width: 1279px)": {
                        vertical: false,
                        center: true,
                    },
                },
            },
        },
        Lazyload: {
            preload: 0
        },
    }, {
        Lazyload,
        Arrows,
        Thumbs
    }).init();

    Fancybox.bind("[data-fancybox]", {
        placeFocusBack: false,
        hideScrollbar: false,
        Hash: false,
    });

}

export default function () {

    BuildGallery();
}


const galleryReload = (images) => {

  
    detailMainCarousel.destroy();


    const container = document.getElementById("detail-carousel");
    container.innerHTML = "";

    images.forEach((pic, index) => {
        const pictureEl = document.createElement("picture");
        pictureEl.dataset.fancybox = "product";
        pictureEl.title = pic.ImageAlt || "";
        pictureEl.className = "f-carousel__slide size-full";
        pictureEl.dataset.thumbSrc = pic.SmallPathName;
        pictureEl.dataset.thumbAlt = pic.ImageAlt || "";
        pictureEl.dataset.src = pic.SourcePathName;

        const source = document.createElement("source");
        source.media = "(max-width: 600px) and (max-resolution: 1.9dppx)";

        source.srcset = pic.SmallPathName;
   

        const img = document.createElement("img");
        img.width = pic.WidthPx; 
        img.height = pic.HeightPx;
        img.alt = pic.ImageAlt || "";
        img.src = pic.SourcePathName;


        pictureEl.appendChild(source);
        pictureEl.appendChild(img);
        container.appendChild(pictureEl);
    });

    BuildGallery();


};

export { galleryReload };